import ReportingYearSelection from "./ReportingYearSelection";
import EmissionsTrendCard from "./EmissionTrendCard";
import StackedEmissionsCard from "./StackedEmissionsCard";

// The two totals cards stay mounted on every view (standing no-jump rule,
// 2026-08-09): they read tenant-wide endpoints that take no entity filter, so
// instead of stepping aside on a narrowed or drilled view (the previous
// behavior, brief section 5 open item 8 option a) they now say "company-wide"
// in their own subtitles and simply keep their place. Unmounting them moved
// the page by two chart cards on every All tick or untick.
export default function EmissionCardLayout({
  availableYears = [],
  reportingYears = [],
}) {
  return (
    <div className="mx-auto max-w-[1600px] space-y-3">
      <ReportingYearSelection
        availableYears={availableYears}
        reportingYears={reportingYears}
      />
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
        <EmissionsTrendCard />
        <StackedEmissionsCard />
      </div>
    </div>
  );
}
